..
<template>
    <div class="form">
        <a-card :title="c_title">
            <a-form-model :model="domainData" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                          :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="json" label="菜单数据" prop="json">

                    <a-textarea
                        v-model="domainData.json"
                        :auto-size="{ minRows: 10, maxRows: 30 }"
                    />
                </a-form-model-item>


                <a-form-model-item :wrapper-col="{ span: 8, offset: 12 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
const m_title = {
    'edituser': '编辑用户'
};
const authMap = {
    1: '账号密码',
    2: '手机号',
    3: '中伦网络公众号',
}
export default {
    data() {
        return {
            m_title,
            authMap,
            c_title: '',
            labelCol: {span: 2},
            wrapperCol: {span: 22},
            rules: {
                username: [
                    {required: true, message: '请输入用户名称', trigger: 'blur'},
                    {min: 1, max: 50, message: '请输入1~20个字符', trigger: 'blur'},
                ], nickname: [
                    {required: true, message: '请输入用户名称', trigger: 'blur'},
                    {min: 1, max: 50, message: '请输入1~20个字符', trigger: 'blur'},
                ],
            },
            confirmLoading: false,
            tLoading: false,
            formItemLayout: 'horizontal',
            domainData: {},
            selecterState: {
                isShow: false,
                rowsType: 'radio' // or 'checkbox'，单选或多选
            },
            is_vue_task: true,
        };
    },
    components: {},

    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    let that = this;
                    this.confirmLoading = true;
                    console.log(this.domainData);
                    // const {params} = this.$route;
                    //编辑
                    this.$store
                        .dispatch({
                            type: "wxmenus/requestForSaveWxMenus",
                            params: this.domainData
                        })
                        .then((response) => {
                            if (response.data.success == '1') {
                                that.message.info(response.data.data.result);

                                // console.log(response)
                                // this.handleCancel()
                                // this.confirmLoading = false;
                            }
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        handleSearchMenus() {
            let that = this;
            that.$store.dispatch({
                type: "wxmenus/requestForWxMenus",
                // params: query
            }).then((res) => {
                console.log(res);
                that.tLoading = false;
                that.domainData = res.data.data

            })
        }
    },
    mounted() {
        this.handleSearchMenus();
        // const {query, params} = this.$route;
        // this.c_title = m_title[params.action];
        // let that = this;
        // if (params.action != "adduser") {
        //     that.$store.dispatch({
        //         type: "wxmenus/requestForWxMenus",
        //         params: query
        //     }).then((res) => {
        //         console.log(res);
        //         that.tLoading = false;
        //         that.domainData = res.data.data
        //
        //     })
        // }

    }
};
</script>

<style lang="less" scoped>
.form_span {
    font-size: 14px;
    font-weight: bolder;
}
</style>
